export const environment = {
    production: false,
    title: 'Staging AWS - Purolator - BIP',
    apiURL:  'https://bip-stg-alb.nonprod-finservices.aws-purolator.com'
  };
  